import moment from 'moment'
import { ReactElement, useContext } from 'react'
import Button from '../Button'
import { EmptySearch } from '../shared/styled/EmptySearch'
import { AppointmentDetails } from './AppointmentDetails'
import { SchedulingWizardContext } from './SchedulingWizard'

export function AppointmentConfirmation({ startDate }: { startDate: string | undefined }): ReactElement {
  const {
    apptType,
    appointmentUnavailable,
    appointmentError,
    createdAppointment,
    currentStep,
    selectedDaySlotIndex,
    providers,
    selectedTimeSlot,
    selectedAvailability,
    setAppointmentUnavailable,
    setAppointmentError,
    setBack,
    setCurrentStep,
    setSelectedTimeSlot,
  } = useContext(SchedulingWizardContext)

  if (!startDate) {
    return <div></div>
  }

  return (
    <div className="flex animate-fade-left flex-col gap-y-6 animate-duration-[400ms] md:grow md:items-center md:justify-center md:px-14">
      {appointmentError && createdAppointment == null ? (
        <>
          <EmptySearch
            icon={() => <></>}
            title="Unable to schedule appointment"
            description="We're having trouble connecting to the scheduling system. Please try again later or call the office to schedule your appointment."
            titleSize="lg"
          />
          <Button
            mode="tertiary"
            size="sm"
            onClick={() => {
              setBack(true)
              setSelectedTimeSlot(undefined)
              setCurrentStep(currentStep - 2)
              setAppointmentError(false)
            }}
            label="Back"
          />
        </>
      ) : appointmentUnavailable && createdAppointment == null ? (
        <>
          <EmptySearch
            icon={() => <></>}
            title="This time is no longer available"
            description="It seems like the appointment time you were trying to book is no longer available. Please go back and try again."
            titleSize="lg"
          />
          <Button
            mode="tertiary"
            size="sm"
            onClick={() => {
              setBack(true)
              setSelectedTimeSlot(undefined)
              setCurrentStep(currentStep - 2)
              setAppointmentUnavailable(false)
            }}
            label="Back"
          />
        </>
      ) : (
        <>
          <span className="text-heading-xl text-strong">Thank you</span>
          <AppointmentDetails
            apptType={apptType!}
            selectedDay={moment(startDate).add(selectedDaySlotIndex, `days`).toISOString()}
            provider={providers.find((p) => p.id === selectedAvailability?.providerId)!}
            selectedTime={selectedTimeSlot!.time}
          />
          <p className="text-body-md font-medium text-default md:px-2 md:text-center">
            Your appointment has been scheduled! A confirmation will be sent to your email address shortly.
          </p>
        </>
      )}
    </div>
  )
}
